import { postApiCall } from "./apiService";

export const appAuth = async (apiAuthDetails = {},appToken = '') => {
    return await postApiCall('common/appAuth',apiAuthDetails,appToken);
}

export const appTokenAuth =async (apiAuthDetails = {},appToken = '') => {
    return await postApiCall('common/appTokenAuth',apiAuthDetails,appToken)
}